const NBColor = Object.freeze({
  RED: 'RED',
  ORANGE: 'ORANGE',
  GREEN: 'GREEN',
  GREY: 'GREY'
})
export default NBColor
// RESERVE BELOW
export type NBColorStrings = typeof NBColor[keyof typeof NBColor]
